import React, { useEffect, useState } from 'react';
import { VehiclePriceFormView } from 'components/VehiclePriceForm/VehiclePriceFormView';
import { FormikProps } from 'formik';
import { BadgesResponse, UpdateDepositValues } from 'types';
import { ClassifiedsService } from 'api';
import { Vehicle } from '@groupelacentrale/classified-core';
import { useUpdateDeposit } from 'providers';
import { RANGE_POSITIONS } from 'utils/vehiclePrice';
import { useBadgesRanges } from 'hooks';

export const UpdateVehiclePriceForm: React.FC<FormikProps<UpdateDepositValues>> = props => {
  const [badges, setBadges] = useState<BadgesResponse | Record<string, never>>();
  const { classified, type } = useUpdateDeposit();

  useEffect(() => {
    if (!badges) {
      ClassifiedsService.getBadges(classified!.vehicle as Vehicle, type!, classified!.zipCode!).then(setBadges);
    }
  }, [classified, type, badges]);

  const refinedQuotation = badges?.refinedQuotation;

  const badgesRanges = useBadgesRanges(refinedQuotation);

  return (
    <VehiclePriceFormView
      {...props}
      vehiclePrice={props.values.vehiclePrice}
      handleSubmit={() => {}}
      onReturn={() => {}}
      positions={RANGE_POSITIONS}
      refinedQuotation={refinedQuotation}
      badgesRanges={badgesRanges}
      showActions={false}
    />
  );
};
